const goalOptions = {
  reach: {
    title: 'rm:objectiveBased.card.reach.title',
    description: 'rm:objectiveBased.card.reach.description',
    recommendedFor: 'rm:objectiveBased.card.reach.recommendedFor.content'
  },
  growth: {
    title: 'rm:objectiveBased.card.growth.title',
    description: 'rm:objectiveBased.card.growth.description',
    recommendedFor: 'rm:objectiveBased.card.growth.recommendedFor.content'
  },
  profitability: {
    title: 'rm:objectiveBased.card.profitability.title',
    description: 'rm:objectiveBased.card.profitability.description',
    observation: 'rm:objectiveBased.card.profitability.observation',
    recommendedFor:
      'rm:objectiveBased.card.profitability.recommendedFor.content'
  }
} as const satisfies Record<
  Goals,
  {
    title: string
    description: string
    observation?: string
    recommendedFor: string
  }
>

export type GrowthGoalMeta = (typeof goalOptions)['growth']
export type ProfitabilityGoalMeta = (typeof goalOptions)['profitability']
export type ReachGoalMeta = (typeof goalOptions)['reach']

export type CampaignGoalMeta =
  | GrowthGoalMeta
  | ProfitabilityGoalMeta
  | ReachGoalMeta
export { goalOptions }
